import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ActivityLogEntry } from '@/types';

export interface ActivityParams {
  limit?: number;
  offset?: number;
  actionType?: string;
  actorId?: string;
  from?: string;
  to?: string;
}

interface ActivityResponse {
  data: ActivityLogEntry[];
  total: number;
  limit: number;
  offset: number;
}

async function fetchGlobalActivity(params: ActivityParams): Promise<ActivityResponse> {
  const { data } = await api.get<ActivityResponse>('/activity', { params });
  return data;
}

export function useGlobalActivity(params: ActivityParams = {}) {
  return useQuery({
    queryKey: ['activity', 'global', params],
    queryFn: () => fetchGlobalActivity(params),
    refetchInterval: 30_000,
  });
}

async function fetchActionTypes(): Promise<string[]> {
  const { data } = await api.get<string[]>('/activity/types');
  return data;
}

export function useActionTypes() {
  return useQuery({
    queryKey: ['activity', 'types'],
    queryFn: fetchActionTypes,
    staleTime: 5 * 60_000,
  });
}
